import React from 'react'
import { Route, Switch } from 'react-router-dom'
import App from './components/App'
import HomePage from './components/content/HomePage'
import Metrics from './components/content/Metrics'
import PrivacyPolicy from './components/content/PrivacyPolicy'
import LegalNotice from './components/content/LegalNotice'
import FrequentlyAsked from './components/content/FAQs'
const Routes = () => (
    <App>
        <Switch>
            <Route exact path="/" component={HomePage} />
            <Route exact path="/Metrics" component={Metrics} />
            <Route exact path="/PrivacyPolicy" component={PrivacyPolicy}/>
            <Route exact path="/LegalNotice" component={LegalNotice}/>
            <Route exact path="/FAQs" component={FrequentlyAsked}/>
        </Switch>
    </App> )

export default Routes